export function VideoBanner() {
	return (
		<div className="relative pt-[56.25%]">
			<iframe
				title="Video Banner"
				src="https://customer-n1ekmntmtgx1a3lg.cloudflarestream.com/eb92837ec4a3608b27cbee8895c502c7/iframe?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-n1ekmntmtgx1a3lg.cloudflarestream.com%2Feb92837ec4a3608b27cbee8895c502c7%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false"
				className="border-none absolute top-0 left-0 h-full w-full -z-0"
				allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
			/>
		</div>
	);
}
